export default "__VITE_ASSET__BHK6D6D4__"